import { PermissionsOfAdmin, PermissionsRemovalKeys } from '@pharmaplan/common';

const { ExpressBooking, Delete, PermanentDelete, Actions, ApproveBooking } = PermissionsRemovalKeys;
const {
  Booking: ExpressBookingPermission,
  Delete: DeletePermission,
  PermanentDelete: PermanentDeletePermission,
  PendingRefunds,
} = PermissionsOfAdmin;

const permissionsKeyMap = {
  [ExpressBookingPermission]: [ExpressBooking, ApproveBooking],
  [DeletePermission]: [Delete],
  [PermanentDeletePermission]: [PermanentDelete],
  [PendingRefunds]: [Actions],
};

export const removeBasedOnPermissions = (
  list: Array<{ key: string }>,
  permissions: Array<PermissionsOfAdmin>,
  can: (param: PermissionsOfAdmin) => boolean,
) => {
  let result: any[] = list;
  const permissionsDisabled = permissions.map((item) =>
    ({
      canDo: can(item),
      permission: item,
    }));

  permissionsDisabled.forEach((item) => {
    const keyToRemove = permissionsKeyMap[item.permission as keyof typeof permissionsKeyMap];
    if (!item.canDo) {
      result = result.filter((inItem) =>
        !keyToRemove.includes(inItem?.key));
    }
  });

  return result;
};
